<template>
    <BlogPaginationList
        :title="$t('newsCommonPage.heading')"
        postsTag="NEWS_LAND_USE"
        routeName="news_common"
        :limit="3"
    />
</template>

<script>
import BlogPaginationList from '@/components/blog/BlogPaginationList';

export default {
    components: {
        BlogPaginationList
    }
}
</script>
